<template>
  <v-tabs
    :value="activeTab"
    background-color="transparent"
    show-arrows
    centered
    height="57px"
    :key="key"
    :style="tabsStyling"
  >
    <v-tabs-slider color="accent"/>
    <v-tab
      v-for="(tab, index) in tabs"
      :key="tab.label"
      style="text-transform: none; font-size: 12px"
      @change="$emit('startTabChange', index)"
    >
      {{ translateLabels ? $tc(getTranslationKey(tab.label), 2) : tab.label }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "Tabs",

  props: {
    tabs: {
      type: Array,
      required: true,
    },

    activeTab: {
      type: Number,
      required: true,
    },

    translateLabels: {
      type: Boolean,
      default: false,
    },

    tabsStyling: {
      type: Object,
      default: {}
    },
  },

  data() {
    return {
      key: 0,
    }
  },

  mounted() {
    setTimeout(() => {
      this.key++;
    }, 1000);
  },

  methods:{
    getTranslationKey(label) {
      return this.$store.getters.getLayerTranslationKey(label);
    },

    stylingDefault() {
      return {}
    }
  },
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/_Organisms/Tabs.vue